import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { CardComponent } from '../../../../core/panels/card.component';

@Component({
  selector: 'app-participant-information',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-1/3">
      <app-card label="Name">
        <app-detail-panel [dataSource]="dataSource" classes="tw-pb-8">
          <app-detail-item label="First Name" name="firstName" />
          <app-detail-item label="Middle Name" name="middleName" />
          <app-detail-item label="Last Name" name="lastName" />
          <app-detail-item label="Prefix" name="prefix" />
          <app-detail-item label="Suffix" name="suffix" />
          <app-detail-item label="Gender" name="gender" />
        </app-detail-panel>
      </app-card>
    </div>
    <div class="tw-basis-1/3">
      <app-card label="Information">
        <app-detail-panel [dataSource]="dataSource" classes="tw-pb-8">
          <app-detail-item
            label="Date Of Birth"
            name="dateOfBirth"
            format="d"
          />
          <app-detail-item label="Tax Status" name="taxStatus" />
          <app-detail-item label="Occupation" name="occupation" />
          <app-detail-item label="Organization" name="organization" />
          <app-detail-item label="Marital Status" name="maritalStatus" />
          <app-detail-item label="Guardian" name="guardian" />
        </app-detail-panel>
      </app-card>
    </div>
  </div>`,
  styles: [],
})
export class ParticipantInformationComponent {
  @Input() dataSource: any;
}
